define([
	"dojo/_base/declare",
	"csi/table/Preferences",
	"../SizeChart",
	"./Table"
], function(declare,Preferences,SizeChart,Table) {

	var	_Preferences = declare(Preferences, {
		constructor: function() {
			this.addCustomOption("sizeChartUnits", SizeChart.valueUnits, false, "SizeChartUnits");
		}
	});

	return declare(Table, {
		prefClass: _Preferences
	});
});